module.exports = __webpack_public_path__ + "Fashion88@2x.png?97992406693d10e0cb39ca68b9fcdf35";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Fashion88@2x.png
// module id = 161
// module chunks = 0